export enum Domains {
	AddressesForm = 'addressesForm',
	AnalyticsReader = 'analyticsReader',
	AtcForm = 'atcForm',
	BackOffice = 'backOffice',
	Cart = 'cart',
	Checkout = 'checkout',
	CIAM = 'CIAM',
	CountryConfiguration = 'countryConfiguration',
	Default = 'default',
	DiscoverBy = 'discoverBy',
	Editorials = 'editorials',
	FeatureFlag = 'featureFlag',
	Footer = 'footer',
	ForYou = 'forYou',
	GiftVoucher = 'giftVoucher',
	Help = 'help',
	Home = 'home',
	Labels = 'labels',
	Legal = 'legal',
	Link = 'link',
	logout = 'logout',
	Menu = 'menu',
	MyAddresses = 'myAddresses',
	MyDetails = 'MyDetails',
	MyMangoStyleClub = 'myMangoStyleClub',
	MyPurchases = 'myPurchases',
	MyReturns = 'myReturns',
	MySubscriptions = 'mySubscriptions',
	Payments = 'payments',
	PDP = 'pdp',
	PLP = 'plp',
	Product = 'product',
	PRODUCT_CARD = 'productCard',
	ProductCustomization = 'productCustomization',
	PromoBanner = 'promoBanner',
	RecoveryPassword = 'recoveryPassword',
	Responsibility = 'responsibility',
	Search = 'search',
	Sitemap = 'sitemap',
	SizeGuide = 'sizeGuide',
	Stores = 'stores',
	PhonePrefix = 'phonePrefix',
}
